export default __webpack_public_path__ + "static/media/haken_nil.e3251d90.mp3";